/* tslint:disable */
/* eslint-disable */
/**
 * back-office-service
 * Back Office Service
 *
 * The version of the OpenAPI document: 0.27.49
 * 
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */

import { mapValues } from '../runtime';
/**
 * 
 * @export
 * @interface TimeslotDisplayDateComponents
 */
export interface TimeslotDisplayDateComponents {
    /**
     * Numeric day of month, e.g. 17
     * @type {string}
     * @memberof TimeslotDisplayDateComponents
     */
    dayOfMonth: string;
    /**
     * Short day of week, e.g. Tue
     * @type {string}
     * @memberof TimeslotDisplayDateComponents
     */
    dayOfWeekShort: string;
    /**
     * Full day of week, e.g. Tuesday
     * @type {string}
     * @memberof TimeslotDisplayDateComponents
     */
    dayOfWeek: string;
    /**
     * Numeric month, e.g. 4
     * @type {string}
     * @memberof TimeslotDisplayDateComponents
     */
    monthNumeric: string;
    /**
     * Short month name, e.g. Apr
     * @type {string}
     * @memberof TimeslotDisplayDateComponents
     */
    monthShort: string;
    /**
     * Full month name, e.g. April
     * @type {string}
     * @memberof TimeslotDisplayDateComponents
     */
    month: string;
    /**
     * Year, e.g. 2025
     * @type {string}
     * @memberof TimeslotDisplayDateComponents
     */
    year: string;
}

/**
 * Check if a given object implements the TimeslotDisplayDateComponents interface.
 */
export function instanceOfTimeslotDisplayDateComponents(value: object): value is TimeslotDisplayDateComponents {
    if (!('dayOfMonth' in value) || value['dayOfMonth'] === undefined) return false;
    if (!('dayOfWeekShort' in value) || value['dayOfWeekShort'] === undefined) return false;
    if (!('dayOfWeek' in value) || value['dayOfWeek'] === undefined) return false;
    if (!('monthNumeric' in value) || value['monthNumeric'] === undefined) return false;
    if (!('monthShort' in value) || value['monthShort'] === undefined) return false;
    if (!('month' in value) || value['month'] === undefined) return false;
    if (!('year' in value) || value['year'] === undefined) return false;
    return true;
}

export function TimeslotDisplayDateComponentsFromJSON(json: any): TimeslotDisplayDateComponents {
    return TimeslotDisplayDateComponentsFromJSONTyped(json, false);
}

export function TimeslotDisplayDateComponentsFromJSONTyped(json: any, ignoreDiscriminator: boolean): TimeslotDisplayDateComponents {
    if (json == null) {
        return json;
    }
    return {
        
        'dayOfMonth': json['dayOfMonth'],
        'dayOfWeekShort': json['dayOfWeekShort'],
        'dayOfWeek': json['dayOfWeek'],
        'monthNumeric': json['monthNumeric'],
        'monthShort': json['monthShort'],
        'month': json['month'],
        'year': json['year'],
    };
}

export function TimeslotDisplayDateComponentsToJSON(value?: TimeslotDisplayDateComponents | null): any {
    if (value == null) {
        return value;
    }
    return {
        
        'dayOfMonth': value['dayOfMonth'],
        'dayOfWeekShort': value['dayOfWeekShort'],
        'dayOfWeek': value['dayOfWeek'],
        'monthNumeric': value['monthNumeric'],
        'monthShort': value['monthShort'],
        'month': value['month'],
        'year': value['year'],
    };
}

